module.exports = __webpack_public_path__ + "static/pendulum_0-051a091a7648a184759596139b8604b9.jpg";